export { default } from 'cccisd-game-ucf-ptsguide';
